// @flow

import { USER_CONFIG_SET, USER_SET } from "../actions"

export default ( state: any = {}, action: any ) => {
  switch ( action.type ) {
  case USER_CONFIG_SET:
    return {
      ...state,
      config: action.config,
    }
  case USER_SET:
    return action.user
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.jsx